import dayjs from "dayjs";

export const DEFAULT_FORM_VALUES = {
  dateRange: [dayjs().subtract(31, "days"), dayjs()],
  searchText: "",
  comment: "",
};

export enum RowAction {
  RULE = "rule",
  CONDITION = "condition",
}

export enum EditorAction {
  TEMPLATE_RULE = "TEMPLATE_RULE",
  NEW_SECTION_RULE = "NEW_SECTION_RULE",
  CLOSE_RULES_DRAWER = "CLOSE_RULES_DRAWER",
  PAGE_CLICK = "PAGE_CLICK",
  XML_EDITOR = "XML_EDITOR",
}

export enum Operators {
  EQUAL = "=",
  NOT_EQUAL = "!=",
  LEASS_THAN_OR_EQUAL = "<=",
  GREATER_THAN_OR_EQUL = ">=",
}

export const OPERATORS = [
  {
    label: Operators.EQUAL,
    value: Operators.EQUAL,
  },
  {
    label: Operators.NOT_EQUAL,
    value: Operators.NOT_EQUAL,
  },
  {
    label: Operators.LEASS_THAN_OR_EQUAL,
    value: Operators.LEASS_THAN_OR_EQUAL,
  },
  {
    label: Operators.GREATER_THAN_OR_EQUL,
    value: Operators.GREATER_THAN_OR_EQUL,
  },
];

export const CONJUNCTIONS = [
  {
    label: "AND",
    value: "AND",
  },
  {
    label: "OR",
    value: "OR",
  },
];

export enum GUIDES {
  GUIDES_TOP_LEFT_V = "guides-top-left-v",
  GUIDES_TOP_RIGHT_V = "guides-top-right-v",
  GUIDES_BOTTOM_LEFT_V = "guides-bottom-left-v",
  GUIDES_BOTTOM_RIGHT_V = "guides-bottom-right-v",
  GUIDES_TOP_LEFT_H = "guides-top-left-h",
  GUIDES_BOTTOM_LEFT_H = "guides-bottom-left-h",
  GUIDES_TOP_RIGHT_H = "guides-top-right-h",
  GUIDES_BOTTOM_RIGHT_H = "guides-bottom-right-h",
}

export const CANVAS_GUIDES = [
  GUIDES.GUIDES_TOP_LEFT_V,
  GUIDES.GUIDES_TOP_RIGHT_V,
  GUIDES.GUIDES_BOTTOM_LEFT_V,
  GUIDES.GUIDES_BOTTOM_RIGHT_V,
  GUIDES.GUIDES_TOP_LEFT_H,
  GUIDES.GUIDES_BOTTOM_LEFT_H,
  GUIDES.GUIDES_TOP_RIGHT_H,
  GUIDES.GUIDES_BOTTOM_RIGHT_H,
];

export enum LEFT_PANELS {
  TEMPLATE_RULES = "TEMPLATE_RULES",
  SECTION_RULES = "SECTION_RULES",
  PAGES_SECTIONS = "PAGES_SECTIONS",
  VERSION_HISTORY = "VERSION_HISTORY",
}

export const DEFAULT_PAGE_STYLE =
  "left: 0px; top: 0px; right:0px; bottom:0px; height: 100%; width: 100%;background-position: 0px 0px;background-repeat:no-repeat;";

export const SectionTypes = {
  USC_SECTION: "usc_section",
  USC_TABLE: "usc_table",
};

export enum CONTEXT_MENU_ACTIONS {
  COPY = "COPY",
  PASTE = "PASTE",
  CUT = "CUT",
  EDIT = "EDIT",
  LOCK = "LOCK",
  DELETE = "DELETE",
}

export const DEFAULT_SELECTED_SECTION_DATA = {
  id: "",
  name: "",
  defaultRule: "input1.Default",
  repeatingAdapterId: 0,
  locked: false,
  left: 0,
  top: 0,
  color: "#ffffff",
  properties: {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
    x: 0,
    y: 0,
  },
  selectedRule: "input1.Default",
  repeatable: false,
};

export enum TableCellAction {
  INSERT_COLUMN_RIGHT = "insertColRight",
  INSERT_ROW_BELLOW = "insertRowBelow",
  DELETE_COLUMN = "deleteColumn",
  DELETE_ROW = "deleteRow",
  CLEAR_CELL = "clearCell",
  DELETE_TABLE = "deleteTable",
}

export const TABLE_CELL_MENU_ITEMS = [
  {
    title: "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.INSERT_COLUMN_RIGHT",
    key: TableCellAction.INSERT_COLUMN_RIGHT,
    icon: "M3.8,0.4c0.3,0,0.5,0.3,0.5,0.6V11c0,0.3-0.2,0.6-0.5,0.6H0.7c-0.3,0-0.5-0.3-0.5-0.6V1c0-0.3,0.2-0.6,0.5-0.6H3.8z M3.7,1.2H0.8v9.7h2.9V1.2z M8.4,2.5c1.9,0,3.5,1.5,3.5,3.5s-1.5,3.5-3.5,3.5S4.9,7.9,4.9,6S6.5,2.5,8.4,2.5z M9.2,3.6H7.6v1.6 L6,5.2v1.6l1.6,0v1.6h1.6V6.8l1.6,0V5.2l-1.6,0V3.6z",
  },
  {
    title: "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.INSERT_ROW_BELLOW",
    key: TableCellAction.INSERT_ROW_BELLOW,
    icon: "M11.6,3.8c0,0.3-0.3,0.5-0.6,0.5H1c-0.3,0-0.6-0.2-0.6-0.5V0.7c0-0.3,0.3-0.5,0.6-0.5H11c0.3,0,0.6,0.2,0.6,0.5V3.8z M10.8,3.7V0.8H1.1v2.9H10.8z M9.5,8.4c0,1.9-1.5,3.5-3.5,3.5s-3.5-1.5-3.5-3.5S4.1,4.9,6,4.9S9.5,6.5,9.5,8.4z M8.4,9.2V7.6H6.8l0-1.6H5.2l0,1.6H3.6v1.6h1.6l0,1.6h1.6l0-1.6H8.4z",
  },
  {
    title: "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.DELETE_COLUMN",
    key: TableCellAction.DELETE_COLUMN,
    icon: "M7.6,2.7C5.8,2.7,4.3,4.2,4.3,6s1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3S9.4,2.7,7.6,2.7z M9.9,6.8l-1.5,0H6.8l-1.5,0V5.2l1.5,0h1.5l1.5,0V6.8z M6.2,9.6V11c0,0.3-0.3,0.6-0.6,0.6H1.7c-0.4,0-0.6-0.3-0.6-0.6V1c0-0.3,0.3-0.6,0.6-0.6h3.8c0.4,0,0.6,0.3,0.6,0.6v1.4C5.9,2.6,5.6,2.7,5.4,2.9V1.2H1.8v9.7h3.6V9.1C5.6,9.3,5.9,9.4,6.2,9.6z",
  },
  {
    title: "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.DELETE_ROW",
    key: TableCellAction.DELETE_ROW,
    icon: "M6,4.3c-1.8,0-3.3,1.5-3.3,3.3S4.2,11,6,11s3.3-1.5,3.3-3.3S7.8,4.3,6,4.3z M8.3,8.4l-1.5,0H5.2l-1.5,0V6.9l1.5,0h1.5l1.5,0V8.4z M2.4,6.1H1c-0.3,0-0.6-0.3-0.6-0.6V1.6C0.4,1.3,0.7,1,1,1H11c0.3,0,0.6,0.3,0.6,0.6v3.8c0,0.4-0.3,0.6-0.6,0.6H9.5C9.4,5.8,9.3,5.6,9.1,5.3h1.7V1.8H1.1v3.6h1.7C2.7,5.6,2.6,5.8,2.4,6.1z",
  },
];

export const DEFAULT_MENU_DATA = {
  previewInvoiceNo: "",
  parameterText: "",
  activePage: 0,
  activeLeftPanel: LEFT_PANELS.PAGES_SECTIONS,
  pagesElement: null,
};
